import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";
const CSEBTechLab=()=>{

return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="School of Pharmaceutical Sciences" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Elevating Learning and Research: Laboratory Facilities at School of Pharmaceutical Sciences" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Welcome to the School of Pharmaceutical Sciences at MVN University, Palwal – a dynamic hub of academic excellence and innovation. We are thrilled to introduce you to our cutting-edge laboratory facilities, meticulously designed to empower students and researchers alike in their pursuit of knowledge and discovery educational and research endeavors. 
    </Typography>
    <div className="cum_heilight text-justify">
        <h4>Laboratory Highlights – Department of Pharmacy</h4>
        <p>MVN University’s Department of Pharmacy is committed to academic excellence, practical proficiency, and research innovation. Our laboratories are fully equipped and meticulously maintained to support the academic curriculum as prescribed by the Pharmacy Council of India (PCI), offering students hands-on experience aligned with current industry standards.</p>
    </div>
    <div className="cum_heilight text-justify">
        <h4>Key Laboratory Facilities:</h4>
        <label>Pharmaceutics Laboratory</label>
        <ul>
            <li>Tablet compression machine, dissolution and disintegration test apparatus.</li>
            <li>Advanced equipment for formulation and evaluation of dosage forms.</li>
        </ul>
        <label>Pharmaceutical Chemistry Laboratory</label>
        <ul>
            <li>Fume hood, reflux setup, and analytical instruments.</li>
            <li>Designed for synthesis, qualitative & quantitative chemical analysis.</li>
        </ul>
        <label>Pharmacology Laboratory</label>
        <ul>
            <li>Instruments for simulation-based pharmacological studies, Light Dark Chamber, Analgesiometer, Elevated Plus Maze, Water Maze, Y- Maze, Rota Rod Apparatus, Student Organ Batch, Well Equipped CCCSEA approved animal House.</li>
            <li>Equipped for experimentation in drug action, toxicity, and pharmacodynamics.</li>
        </ul>
        <label>Pharmacognosy Laboratory</label>
        <ul>
            <li>Microscopy and chromatography facilities for crude drug analysis.</li>
            <li>Tools for extraction, isolation, and phytochemical evaluation of natural products.</li>
        </ul>
        <label>Pharmaceutical Analysis Laboratory</label>
        <ul>
            <li>UV-Visible spectrophotometer and digital pH meter.</li>
            <li>Designed for quality control, validation, and assay of pharmaceuticals.</li>
        </ul>
        <label>Microbiology & Biotechnology Laboratory</label>
        <ul>
            <li>Laminar airflow, autoclaves, incubators, B.O.D incubator and biosafety measures.</li>
            <li>Supports aseptic techniques, microbial testing, and biotechnology practices.</li>
        </ul>
        <label>Central Instrumentation Room</label>
        <ul>
            <li>Houses sophisticated analytical instruments like HPLC, Brookfield viscometer, Karl fischer Titrimeter, Nephelo Turbidity meter and digital balances.</li>
            <li>Available for advanced research and analytical support.</li>
        </ul>
        <label>Computer Laboratory</label>
        <ul>
            <li>Software for molecular modelling, simulation, and research data analysis.</li>
            <li>High-speed internet access and academic databases.</li>
        </ul>
    </div>
    <div className="cum_heilight text-justify">
        <h4>Salient Features:</h4>
        <ul>
            <li>Laboratories aligned with PCI norms and regulatory standards.</li>
            <li>Periodic calibration and maintenance of equipment.</li>
            <li>Emphasis on safety protocols and Good Laboratory Practices (GLP).</li>
            <li>Industry-oriented training and project-based learning.</li>
            <li>Integration of digital tools and e-learning resources.</li>
        </ul>
    </div>
    <br></br>
    </Grid>
    </Grid>

)
}
export default CSEBTechLab;